<div *ngIf="cmdbMountPoint">
  <div class="stick-top">
    <mat-toolbar
      ><mat-icon>device_hub</mat-icon>
      {{
        cmdbMountPoint.id ? "Mount Point - " + cmdbMountPoint.name : "Create new Mount Point"
      }}</mat-toolbar
    >
    <div class="hbox lightly-padded button-bar">
      <button
        mat-raised-button
        class="primary"
        type="button"
        (click)="save()"
        [disabled]="!form.form.valid"
      >
        <mat-icon>{{ cmdbMountPoint.id ? "save" : "add" }}</mat-icon>
        {{ cmdbMountPoint.id ? "Update" : "Add" }}
      </button>
      <micro-delete-confirm
        *ngIf="cmdbMountPoint.id"
        (onConfirm)="delete()"
      ></micro-delete-confirm>
    </div>
  </div>
  <div class="padded">
    <form #form="ngForm" role="form">
      <table class="basicTable vtable">
        <thead>
          <tr>
            <th colspan="100">Mount Point Details</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="auth.isCompanyAdmin()"><th>Company</th><td><micro-company-select [(companyId)]="cmdbMountPoint.companyId" [required]="true"></micro-company-select></td></tr>
          <tr>
            <th>
              <micro-valid-label
                for="name"
                [model]="name"
                label="Name"
              ></micro-valid-label>
            </th>
            <td>
              <input
                #name="ngModel"
                [(ngModel)]="cmdbMountPoint.name"
                required
                maxlength="50"
                id="name"
                name="name"
              />
            </td>
          </tr>
          <tr>
            <th>OS Type</th>
            <td>
              <micro-select-pagination
                apiUrl="/domain/cmdbOsType"
                [(id)]="cmdbMountPoint.osTypeId"
                [defaultOption]="selectedOsType"
                placeholder="OS Type"
                (objectChange)="onOsTypeChange($event)"
              ></micro-select-pagination>
            </td>
          </tr>
          <tr>
            <th>Purpose</th>
            <td>
              <input
                [(ngModel)]="cmdbMountPoint.purpose"
                maxlength="200"
                id="purpose"
                name="purpose"
              />
            </td>
          </tr>
          <tr>
            <th>Status</th>
            <td>
              <micro-select-pagination
                apiUrl="/domain/cmdbMountStatus"
                [(id)]="cmdbMountPoint.statusId"
                [defaultOption]="selectedStatus"
                placeholder="Select status"
                (objectChange)="onStatusChange($event)"
              ></micro-select-pagination>
            </td>
          </tr>
          <tr>
            <th>Type</th>
            <td>
              <micro-select-pagination
                apiUrl="/domain/cmdbMountTypes"
                [(id)]="cmdbMountPoint.typeId"
                [defaultOption]="selectedMountType"
                placeholder="Select mount Type"
                (objectChange)="onMountTypeChange($event)"
              ></micro-select-pagination>
            </td>
          </tr>
          <tr>
            <th>File System</th>
            <td>
              <micro-select-pagination
                apiUrl="/domain/CmdbFileSystems"
                [(id)]="cmdbMountPoint.fileSystemId"
                [defaultOption]="selectedFileSystem"
                placeholder="Select file system"
                (objectChange)="onFileSystemChange($event)"
              ></micro-select-pagination>
            </td>
          </tr>
          <tr>
            <th>Min Size</th>
            <td>
              <input
                type="number"
                [(ngModel)]="cmdbMountPoint.minSize"
                id="minSize"
                name="minSize"
              />
            </td>
          </tr>
          <tr>
            <th>Max Size</th>
            <td>
              <input
                type="number"
                [(ngModel)]="cmdbMountPoint.maxSize"
                id="maxSize"
                name="maxSize"
              />
            </td>
          </tr>
          <tr>
            <th>Separate Disk</th>
            <td>
              <input type="checkbox" [checked]="cmdbMountPoint.seperateDisk === 'Y'" (change)="onCheckboxChange('seperateDisk', $event)" id="seperateDisk" name="seperateDisk">
            </td>
          </tr>
          <tr>
            <th>Description</th>
            <td>
              <textarea
                [(ngModel)]="cmdbMountPoint.description"
                maxlength="200"
                id="description"
                name="description"
                style="min-width: 350px; min-height: 100px;"
              ></textarea>
            </td>
          </tr>
          <tr>
            <th [ngClass]="cmdbMountPoint.active !== 'Y' ? 'CRITICAL' : ''">
              <micro-valid-label
                for="active"
                label="Active"
              ></micro-valid-label>
            </th>
            <td>
              <input type="checkbox" [checked]="cmdbMountPoint.active === 'Y'" (change)="onCheckboxChange('active', $event)" id="active" name="active">
            </td>
          </tr>
        </tbody>
      </table>
    </form>
  </div>
</div>
